import { Draft } from "@reduxjs/toolkit";

import { TKPIDataVisualizationState, TUpdateKpiDataVisualizationPayload } from "./types";

/**
 * Applies partial visualization updates to a KPI entry and recalculates its dirty state.
 *
 * @param {Draft<TKPIDataVisualizationState>} state
 *   Immer draft of the KPI data visualization slice state.
 *
 * @param {TUpdateKpiDataVisualizationPayload} payload
 *   Payload containing:
 *   - `messageId`: Identifier of the KPI entry to update
 *   - `changes`: Partial visualization data to merge into the existing entry
 *
 * @returns {void}
 */
export function applyKpiVisualizationUpdate(
  state: Draft<TKPIDataVisualizationState>,
  payload: TUpdateKpiDataVisualizationPayload
) {
  const { messageId, changes } = payload;
  const entry = state.entities[messageId];

  if (!entry) return;

  entry.data = {
    ...entry.data,
    ...changes,
  };
  entry.isDirty =
    JSON.stringify(entry.data) !== JSON.stringify(entry.savedData);
}
